import { apiService } from './api/api';
import { User } from '../types/user';
import { API_ENDPOINTS } from '../constants/api';

export const userService = {
  async getAllUsers(): Promise<User[]> {
    return apiService.get<User[]>(API_ENDPOINTS.USER.UPDATE);
  },
  async getUserById(id: string): Promise<User | null> {
    try {
      const res = await apiService.get<User>(`${API_ENDPOINTS.USER.UPDATE}/${id}`);
      return res;
    } catch (error) {
      console.error(`Error fetching user ${id}:`, error);
      return null;
    }
  },
};
